import type { MediaImageSource, MediaImageVersions } from 'shared/library/media-image-versions';

// Signed R2 recipes of design images in the media library. The signature covers only the
// recipe, so every family and width below is a valid media worker URL.
const STATIC_IMAGES = {
  andre: {
    recipe:
      'eyJ2ZXJzaW9uIjoiY2YtbWVkaWEtdjEiLCJrZXkiOiJvcmlnaW5hbHMvMWZkYjEzMzQtYjdiYy01YWQwLTg4ODEtYjdlNDUyNzJjYjRjLzYwNGMzMzlkLTFmNzAtNWFkNy1hYzA3LWU0YjVlNWJmMGQ4NyIsImZhbGxiYWNrIjpudWxsLCJzb3VyY2UiOnsidXJsIjoiIiwic2hhMjU2IjoiYzdiMmFhZjcwNjk0OTk1YjY5NDZmNzQ4YzZmYjA3NjUyYTllMDg5NTRiZDVkZmM2ODM5MDdmYTQ2YjExZWViMSIsIndpZHRoIjo4OTYsImhlaWdodCI6MTA1OH0sImNyb3BzIjp7fX0',
    sig: 'b509fcfbc02d41c324a500dcf212bd1a692722d02d793c7e0f0832ef9a4e619b',
    width: 896,
    height: 1058,
  },
  'arken-zoo-logo': {
    recipe:
      'eyJ2ZXJzaW9uIjoiY2YtbWVkaWEtdjEiLCJrZXkiOiJvcmlnaW5hbHMvNTU3Yjg4OWMtNWVjOC01MGRlLWIyMzItNmU0OWY2ZDA2YWYwL2ZjNWNiMjk3LTJkOTUtNTEzNi05NzZkLWZlODBmNjhkOTI4NSIsImZhbGxiYWNrIjpudWxsLCJzb3VyY2UiOnsidXJsIjoiIiwic2hhMjU2IjoiZTA5MGI0Nzk0YmFhZTgzNDk3MGFjN2Q5ODQ3ZjA0NDk1ZTU4M2FkMWVlNmRiMWJhMTgwMDNmZTg5ZWUwMTIyYSIsIndpZHRoIjoyNTYwLCJoZWlnaHQiOjQxOX0sImNyb3BzIjp7fX0',
    sig: '5d5d6c21cdc62e46f057c0541c15cbeb8e44b7dd71e0600f0aff75b6379a301b',
    width: 2560,
    height: 419,
  },
  'beagle-litter': {
    recipe:
      'eyJ2ZXJzaW9uIjoiY2YtbWVkaWEtdjEiLCJrZXkiOiJvcmlnaW5hbHMvMzlmOTMwZTgtY2VkNi01ZDhhLWFiNDUtNjE0MDA5NmQzMzUzLzk3YzlhNTVkLTM2MTAtNWNhMi04MTM4LTMyNjBkOTA2MDY0YSIsImZhbGxiYWNrIjpudWxsLCJzb3VyY2UiOnsidXJsIjoiIiwic2hhMjU2IjoiOTQzMTU1OTBkZjlhNGU2NDVmYjMxNzY4OGIzMTQ2YTAwMDE4Y2MyNDM3NTkzMjlkMzYzMGNhN2FkOGU0YWM0YyIsIndpZHRoIjoxMzc2LCJoZWlnaHQiOjc2OH0sImNyb3BzIjp7fX0',
    sig: '6a946a1276ae790e948fe1190e66aea002ff48e80cb4b43ca5bc724b039e6dd4',
    width: 1376,
    height: 768,
  },
  'dog-and-bed': {
    recipe:
      'eyJ2ZXJzaW9uIjoiY2YtbWVkaWEtdjEiLCJrZXkiOiJvcmlnaW5hbHMvMGI4NDkxN2MtMjE0ZS01ZmNmLTkyZTktNDUzMmMxN2QzZWU2LzE3MTVmM2YzLThiYzEtNTMyNC1iY2U1LTk3ZTRkMWFhMDJhYSIsImZhbGxiYWNrIjpudWxsLCJzb3VyY2UiOnsidXJsIjoiIiwic2hhMjU2IjoiNzYyOGQ2ODQyZGFkNjhmMjE3MmJkNTc5NjUzY2U0YTU5ZGZjMzBhMDY2MTczNDFiNGI0MTlkYmI1MjBlYzZhMyIsIndpZHRoIjoxNDU2LCJoZWlnaHQiOjgxNn0sImNyb3BzIjp7fX0',
    sig: '4e74b485d5de9c4273c4261277e6d5cab5e95f6538113709186d26e32fb1b739',
    width: 1456,
    height: 816,
  },
  'kitten-litter': {
    recipe:
      'eyJ2ZXJzaW9uIjoiY2YtbWVkaWEtdjEiLCJrZXkiOiJvcmlnaW5hbHMvNDFiZjY3MTAtZjkwNi01MGZlLWJhZWYtYTE4N2VmNzUyODBkLzQ2OWViMjIwLTdlOWQtNTVmYi1hMjY1LWZiZDhlNzQ0N2Q1ZCIsImZhbGxiYWNrIjpudWxsLCJzb3VyY2UiOnsidXJsIjoiIiwic2hhMjU2IjoiMGU2Y2UyYzIxNTRlOWFlY2YxZDM2ZTI4YmRhOGRiMGRmODIyNzA1Yjc3ZTU1NGZkNmY4YTY4ZTA2ZDdhMzMyOCIsIndpZHRoIjoxMzc2LCJoZWlnaHQiOjc2OH0sImNyb3BzIjp7fX0',
    sig: '289018d7218cae18f9bab2885d80366bf6dc4e1d4739c882557e51265c86860d',
    width: 1376,
    height: 768,
  },
  'logo-monochrome-light': {
    recipe:
      'eyJ2ZXJzaW9uIjoiY2YtbWVkaWEtdjEiLCJrZXkiOiJvcmlnaW5hbHMvYTg1MzNkMTgtZGJiMi01YTAwLWI5ODAtZjM1OWEwNmJmYjRkLzliNTU3YjI5LWUwOTgtNTk5Zi04NDM5LWNhMDkxNGI1MTNlMSIsImZhbGxiYWNrIjpudWxsLCJzb3VyY2UiOnsidXJsIjoiIiwic2hhMjU2IjoiOTIzZDkxMmM5ZDU3NDZkZTkxMDI4ZjJjOGI1YWE3MTA4MzI4NTk2MTliYzllMzMwYTI4ZWM2Mzk2MWNmZDBlNCIsIndpZHRoIjo3MjgsImhlaWdodCI6MjE0fSwiY3JvcHMiOnt9fQ',
    sig: 'fcc264efdd9daadb84d26b1aef9f0a0ac849f48854e4a013f79cc34be50f7350',
    width: 728,
    height: 214,
  },
  'map-marker': {
    recipe:
      'eyJ2ZXJzaW9uIjoiY2YtbWVkaWEtdjEiLCJrZXkiOiJvcmlnaW5hbHMvY2M5NjI3NzQtYjY5MC01MGNmLWE2MjUtN2U5MDIxMWNiZmE1LzJkODUyNWJiLWNiYTktNTNhOS1hODFhLTM2YzYwYjI3M2IxMCIsImZhbGxiYWNrIjpudWxsLCJzb3VyY2UiOnsidXJsIjoiIiwic2hhMjU2IjoiZGEyOTBiNjdmMGM4Y2NmYTA3MTBhNWI0NzU0NjFlNDVlM2ZhYmQxMDlhMjc3NmEwNzA5ZDY4MWZlMDFhZTdkOCIsIndpZHRoIjoxMDAsImhlaWdodCI6MTAwfSwiY3JvcHMiOnt9fQ',
    sig: '01dea25fd7c6508494f342b044ca519bd36e27b80caf04e1eae3675f2461400c',
    width: 100,
    height: 100,
  },
  'maxi-zoo-logo': {
    recipe:
      'eyJ2ZXJzaW9uIjoiY2YtbWVkaWEtdjEiLCJrZXkiOiJvcmlnaW5hbHMvOTBkNzk4NmEtZDBiOC01Y2RjLTkxYjEtODIwYTQwNzg0ODYzLzhiNjZlZWVkLTA4YzgtNTdlOC04N2UwLWNhOTNhN2RhNGIzNSIsImZhbGxiYWNrIjpudWxsLCJzb3VyY2UiOnsidXJsIjoiIiwic2hhMjU2IjoiMzJlZDc1YTBmODQzZjhmN2Y2YmUxNDYzYzIyNmJlZDJiNzc0MDE0ZjNjNjVkYzZhY2EyYjc4NTU2ZThmOWM4ZSIsIndpZHRoIjo3NTYsImhlaWdodCI6MjAwfSwiY3JvcHMiOnt9fQ',
    sig: 'd6382b5f75875fd1c3ce1d4d314aaa269f1b2b4b6e0799c940eb710a54e78622',
    width: 756,
    height: 200,
  },
  'mom-with-puppies': {
    recipe:
      'eyJ2ZXJzaW9uIjoiY2YtbWVkaWEtdjEiLCJrZXkiOiJvcmlnaW5hbHMvZmU5Y2JlODctNzA5My01ZjljLWIwNzMtYzY5ZjA4MmJkMWVlL2Y3NmQ3MzZmLTlkODUtNWViNC05NWU5LTRhNWQwNTBmYzU2NSIsImZhbGxiYWNrIjpudWxsLCJzb3VyY2UiOnsidXJsIjoiIiwic2hhMjU2IjoiMzQ4MzdmMjUwNjBkNzkyMzg3NTM4NDM2MjQyYzVlNWVmOTg2NDI2MzQwZDJhYWRkZDY5MTY3YjJiN2FmMmM1ZSIsIndpZHRoIjoxMDI0LCJoZWlnaHQiOjEwMjR9LCJjcm9wcyI6e319',
    sig: '44d71e07da732c7194f312afbbb4a729d1cc778e3e9f6750573ef76a921fff14',
    width: 1024,
    height: 1024,
  },
  'musti-fi-logo': {
    recipe:
      'eyJ2ZXJzaW9uIjoiY2YtbWVkaWEtdjEiLCJrZXkiOiJvcmlnaW5hbHMvZmVjYjIxNjQtNTZlZS01MjAzLTgzOTMtOGQwMmE5OTAxMjE5LzlhN2ZiYzExLWU4ZTUtNWUyNi05NGRhLTlmYTRiMWU3Y2Y4MiIsImZhbGxiYWNrIjpudWxsLCJzb3VyY2UiOnsidXJsIjoiIiwic2hhMjU2IjoiZWYwZTFiMTY2OWE1M2IxMzdlOGViMWY4MDAyYjg4ZjYzZDRlNDdjMTRmYTA5NTEyMGFmOTJlYjY5ZTdiYzNjZSIsIndpZHRoIjoxMjAwLCJoZWlnaHQiOjI2Mn0sImNyb3BzIjp7fX0',
    sig: 'aa9ca6db77415b3db2cebb7737e8fe1e5726cc3f2902e675564a7412f9ce1f90',
    width: 1200,
    height: 262,
  },
  'musti-logo': {
    recipe:
      'eyJ2ZXJzaW9uIjoiY2YtbWVkaWEtdjEiLCJrZXkiOiJvcmlnaW5hbHMvOWJmMWQzNWMtYTRjZC01NjkxLTg1YjItN2M4ZGU1MzE5ZWU2LzAwY2RmYmNkLTRjYTMtNTZlNC05MGUxLTE2YmU0NDI0MDcwNiIsImZhbGxiYWNrIjpudWxsLCJzb3VyY2UiOnsidXJsIjoiIiwic2hhMjU2IjoiMWZiMmZjMDhlNDllODcyZWNkMWYxYTMwNWY2NzJmODg5ZmU4MDU1NWU4YmY1NWI5MzBiNjE2NjUyYmFlMGJkZSIsIndpZHRoIjoxMjAwLCJoZWlnaHQiOjgwMH0sImNyb3BzIjp7fX0',
    sig: 'b17ead20c5ef425fe2f33dd2a4377d0f647c2ef045838e7043878faa64b925d8',
    width: 1200,
    height: 800,
  },
  'new-owner-of-puppy': {
    recipe:
      'eyJ2ZXJzaW9uIjoiY2YtbWVkaWEtdjEiLCJrZXkiOiJvcmlnaW5hbHMvM2YwODBiYWItMGMyYS01NWZlLWI4MzYtZjQ5MjFlZGUzMjFlL2ZkYmM1NzgzLWQwOTYtNTVkMS1iYzUyLWY4ZmFhYTRjYjg1YyIsImZhbGxiYWNrIjpudWxsLCJzb3VyY2UiOnsidXJsIjoiIiwic2hhMjU2IjoiNDJhNTMwMmMxMzY4OTg0MjcxNzlkNTExZjU4ZTJjNjEyYmE4MjFjYTE2NGVmNTFiYzEyZjNmNzJhYTQxNmUxZiIsIndpZHRoIjoxMDI0LCJoZWlnaHQiOjEwMjR9LCJjcm9wcyI6e319',
    sig: '757d53973bf9e98499ea7fa3337e29f83e21b0104d0fd3787266b9ebdfb627e3',
    width: 1024,
    height: 1024,
  },
  'open-graph': {
    recipe:
      'eyJ2ZXJzaW9uIjoiY2YtbWVkaWEtdjEiLCJrZXkiOiJvcmlnaW5hbHMvMzc5OGNkZTgtNzgxYi01OGRhLWE5YjQtYzkxMTBlYzViMmQ2L2JlNmJiNzQ5LWI1MGYtNTNhYi1hOWRkLTRjYTJkZmQwMTk5NSIsImZhbGxiYWNrIjpudWxsLCJzb3VyY2UiOnsidXJsIjoiIiwic2hhMjU2IjoiMWI4Yjc0NGFmNmI2MTVjNTA5YzQ4YjVkZGM3ZWNlOGEyZDZmZTdiMjJmZjNjOTU4YjExNmZlZTNlZjgxN2E0NyIsIndpZHRoIjoxMjAwLCJoZWlnaHQiOjYzMH0sImNyb3BzIjp7fX0',
    sig: '42274fd6877d2005bddccf13d34a1b54b1c3c4a270b0429a6ef66580fc4ab960',
    width: 1200,
    height: 630,
  },
  'postnord-logo': {
    recipe:
      'eyJ2ZXJzaW9uIjoiY2YtbWVkaWEtdjEiLCJrZXkiOiJvcmlnaW5hbHMvYWY1YTdkNDYtOGNhZi01ODdjLTgxOGItYmE5OTgzNGQxOGFmLzBjZjUzMDY5LWNkNTctNTY3Yi05NmYzLTU0ZDI2NzM4ZDc2ZiIsImZhbGxiYWNrIjpudWxsLCJzb3VyY2UiOnsidXJsIjoiIiwic2hhMjU2IjoiNGZkOTU4YjkxZmQxZDhiODQ4ODg1ZTRjMWE3NTg1NTQxYTM3ZTlmNmIwNDM1NTgwMzUzNDQ5MGQ3ZTBhMzg1MiIsIndpZHRoIjo4ODYsImhlaWdodCI6MTY3fSwiY3JvcHMiOnt9fQ',
    sig: 'af7dcd637edf4b5b6690463da234edb5111cf6a22140071391ac6171a7440b2c',
    width: 886,
    height: 167,
  },
  'puppy-and-kid-playing-in-snow': {
    recipe:
      'eyJ2ZXJzaW9uIjoiY2YtbWVkaWEtdjEiLCJrZXkiOiJvcmlnaW5hbHMvNzZhZTJhZTAtN2VmZi01YWRjLThkMmItNjg3NzgzMjQyMGViL2Y4NDQ3YmEyLWUzNDMtNTljZi1hNzNkLTU0OTBiZGZjMDlhZCIsImZhbGxiYWNrIjpudWxsLCJzb3VyY2UiOnsidXJsIjoiIiwic2hhMjU2IjoiOGViMmEyNGMzYjFiNTZiY2JhNTljMDRjZWY0MmFiMmQ4YWE2MmVmYTgwODA0NGZjYzVjZTJmZmNiOTBhMGUwZCIsIndpZHRoIjoxMDI0LCJoZWlnaHQiOjEwMjR9LCJjcm9wcyI6e319',
    sig: 'a0d8ad9194de6ec6abe64e596f85b8402910d414d0e5f20ffc76e709161f1c3b',
    width: 1024,
    height: 1024,
  },
  'puppy-and-kitten': {
    recipe:
      'eyJ2ZXJzaW9uIjoiY2YtbWVkaWEtdjEiLCJrZXkiOiJvcmlnaW5hbHMvZDhkODg2ZmMtYjM5ZC01OGM2LTk1YzctMTgxMjRkZjk0ZjdjLzBlYTFkNDY0LTNiNTYtNWQ5ZC04NjQzLWIxZDVlYzhiN2E0MCIsImZhbGxiYWNrIjpudWxsLCJzb3VyY2UiOnsidXJsIjoiIiwic2hhMjU2IjoiYmY1MzIyNDdhMzlkMTRiMmZmYzExNjgxYzhmY2ZjZGRlZmNlODRhYjY4MDQ0M2FmZjRjYmMwYWVjNDQ4YjEyNSIsIndpZHRoIjoxMDI0LCJoZWlnaHQiOjEwMjR9LCJjcm9wcyI6e319',
    sig: '239c30254b1a86573cee8fbe82b2635fa14288c2ce78d6a0c28579bd1848f674',
    width: 1024,
    height: 1024,
  },
  'puppy-by-table': {
    recipe:
      'eyJ2ZXJzaW9uIjoiY2YtbWVkaWEtdjEiLCJrZXkiOiJvcmlnaW5hbHMvZWFlZmZhZWQtMTg1OC01NDlkLWJkZGQtYmYyZGFjNmQ0NjdiLzJiOWVkY2I4LWE2NTItNTQ5ZS04MTQzLWQ0M2Y2YTA5NzVjMyIsImZhbGxiYWNrIjpudWxsLCJzb3VyY2UiOnsidXJsIjoiIiwic2hhMjU2IjoiMGNmMTA5NzViNTZiNWJiY2UwZDRhMmNiOGZiNzBkNzdkNTZiMWRhYmM5ZWQ0YjA0ODYyODM5NWI0YmI0ZTU1MSIsIndpZHRoIjoxMDI0LCJoZWlnaHQiOjEwMjR9LCJjcm9wcyI6e319',
    sig: '3f5bcbe83f31fed5484ae188b1c35fd523db016ef055aec7cb3d010561ab0d7a',
    width: 1024,
    height: 1024,
  },
  'puppy-cozy-sofa': {
    recipe:
      'eyJ2ZXJzaW9uIjoiY2YtbWVkaWEtdjEiLCJrZXkiOiJvcmlnaW5hbHMvYjgwZWU0NWQtODc0Yy01YTdmLWJkN2UtNzBjOGUxYzk5ZGQ2LzEwYzgzMjQ5LTQ3NTYtNTJmYi05YjA5LTQ0OTlkZTM4N2UwMCIsImZhbGxiYWNrIjpudWxsLCJzb3VyY2UiOnsidXJsIjoiIiwic2hhMjU2IjoiMDJiYTE1MDljZmYyNzg2NTc1ZmFmMjlhYjM1MzlhNzY0YTdmZjVmOWY0ZmZhYWIzYjZmMTJiMmE4OGMyYzdkMCIsIndpZHRoIjoxMDI0LCJoZWlnaHQiOjEwMjR9LCJjcm9wcyI6e319',
    sig: '7ba844c06d0ab78eeab115ec55b5fcf222c0a20c8186e4df5b1bd63110b3be5e',
    width: 1024,
    height: 1024,
  },
  'review-black-oranges': {
    recipe:
      'eyJ2ZXJzaW9uIjoiY2YtbWVkaWEtdjEiLCJrZXkiOiJvcmlnaW5hbHMvMjFkMzMwNTEtZWZhMS01MTEwLWI2YTQtYThlNTVmZWRhODZiLzYzMmNlNzEwLThlYWYtNWYyMy04NDVhLTMzZTMyZGFkYTNhOCIsImZhbGxiYWNrIjpudWxsLCJzb3VyY2UiOnsidXJsIjoiIiwic2hhMjU2IjoiY2JjOTUyYTNkMThlNGZjZWJjZWNjY2I0MzJkMjQ3NDVlNjRlNDNjMjMxZDBiYjc3Y2IxOWVlOWNiNGUwMjhkNyIsIndpZHRoIjoxMDgwLCJoZWlnaHQiOjYyOH0sImNyb3BzIjp7fX0',
    sig: '4f5db608c7b8effe556640d397720f04b3a67cec8e75b84f2da80ae12765276a',
    width: 1080,
    height: 628,
  },
  'review-cecilias-stars': {
    recipe:
      'eyJ2ZXJzaW9uIjoiY2YtbWVkaWEtdjEiLCJrZXkiOiJvcmlnaW5hbHMvMzc3NjcyYTctNGUzMC01YzczLWJiY2QtZjZmZTQzOTk5NjQ2L2Q5NGNmZjk4LTYwODctNTFjMi1hMTFmLWRkNzc3M2Y5ODM2OCIsImZhbGxiYWNrIjpudWxsLCJzb3VyY2UiOnsidXJsIjoiIiwic2hhMjU2IjoiYzgxNmY4OTUxZmJiOWY5YzA5ZDM3NTA2MjdmZjcwZGQ2ZmQ4MWI2MjEyM2M4NGIyZTU0Mjk0YjY4MTlhNmRmMiIsIndpZHRoIjoyMDQ4LCJoZWlnaHQiOjEzNjZ9LCJjcm9wcyI6e319',
    sig: '25ebd4659a5f783df767bd75ad6c7b54de4d5c0543ddadcfbc9d1241aa89c20c',
    width: 2048,
    height: 1366,
  },
  'review-chillipax': {
    recipe:
      'eyJ2ZXJzaW9uIjoiY2YtbWVkaWEtdjEiLCJrZXkiOiJvcmlnaW5hbHMvOTYwNzJkMTAtNDY2ZS01MmI3LWIzNTgtZjUzOTNjYTRiNjI2L2I2YjMwNThhLWMzMTctNTBkYS04OWQ2LTUxMTM1MmRkZWJkZCIsImZhbGxiYWNrIjpudWxsLCJzb3VyY2UiOnsidXJsIjoiIiwic2hhMjU2IjoiOTBhYzI0YTdiYWM3MDNlODIwZThjMGVlNGE2NzFhMDZlY2Q1M2QxMzY4NWNjZmJlNjY4OGUwYjZkY2M2Mjc1NiIsIndpZHRoIjoyNTAwLCJoZWlnaHQiOjMzMzN9LCJjcm9wcyI6e319',
    sig: '62d9db7cc1935c0ab1c5949719a8ef01752d79d500f067b12c5a25291c19ff9e',
    width: 2500,
    height: 3333,
  },
  'review-fredduvans': {
    recipe:
      'eyJ2ZXJzaW9uIjoiY2YtbWVkaWEtdjEiLCJrZXkiOiJvcmlnaW5hbHMvNzg4ZjU5NWYtYWE4Mi01Yjc5LWJlZjYtZmM1ZWVjNjYzODRjL2U5Mjk5YTI2LTE1Y2QtNTk1Ny1hY2JjLTRjMDhhMDZmYmRmMiIsImZhbGxiYWNrIjpudWxsLCJzb3VyY2UiOnsidXJsIjoiIiwic2hhMjU2IjoiZmYxZWMzYTBjYjlmYmQxNDNhODgwNDE4MDA4MDM2Y2YyMTQ3ZWUyZjEyNTA2OTk1OTRhNjgxOWY4MjlmNmQzZCIsIndpZHRoIjoxNTM2LCJoZWlnaHQiOjIwNDh9LCJjcm9wcyI6e319',
    sig: 'b0bec8933984536db977d0cea67f84ab5a88bb7d276a0feeb56bf5014ee34b7e',
    width: 1536,
    height: 2048,
  },
  'review-lugnets': {
    recipe:
      'eyJ2ZXJzaW9uIjoiY2YtbWVkaWEtdjEiLCJrZXkiOiJvcmlnaW5hbHMvYjlkNGRmMzUtZDY5MS01ZWVlLWFhYWEtYTAwMDA5MDA0Y2IwL2Y1ZjMzNWVhLWE2YzQtNTBmNy04MjI3LWExYjhhZWQwZGRhZCIsImZhbGxiYWNrIjpudWxsLCJzb3VyY2UiOnsidXJsIjoiIiwic2hhMjU2IjoiZWU1NmM5N2RiNDEzOGY4OGYyNjg2ZTAwOTU5YzdjMDI2ODUxMjVmMGRlMzViNTMyNjg4NTk1MmIwNDMxYWViMyIsIndpZHRoIjo2NDAsImhlaWdodCI6NDY1fSwiY3JvcHMiOnt9fQ',
    sig: '9f8c4d744431257105941fe313dd28f3947ebaa035d8c965cbabf342eb94f62e',
    width: 640,
    height: 465,
  },
  'review-royal-inferno': {
    recipe:
      'eyJ2ZXJzaW9uIjoiY2YtbWVkaWEtdjEiLCJrZXkiOiJvcmlnaW5hbHMvNTFiNTc4NzktODFjOC01YzY2LWE1YTYtMjQxY2UxMmU3YzRjLzI5YzQxN2JkLTg4ZjQtNWYyNC1hNzBjLTdhYWQ3MGNiOWQ0ZiIsImZhbGxiYWNrIjpudWxsLCJzb3VyY2UiOnsidXJsIjoiIiwic2hhMjU2IjoiZmFhOTMwNmIxMjRlYjM0Yzg2MTkxODhkNmRlZTRhY2NjYThkOGMxNjk5ZjIyNzQ2NGY1N2NjZDk4NTExMDAyNSIsIndpZHRoIjoyMzE2LCJoZWlnaHQiOjMwODh9LCJjcm9wcyI6e319',
    sig: '3cf3d6d47ccab7846d6a70d8ee362592f1a0cf250795c471d52433663382fb85',
    width: 2316,
    height: 3088,
  },
  'shop-hero': {
    recipe:
      'eyJ2ZXJzaW9uIjoiY2YtbWVkaWEtdjEiLCJrZXkiOiJvcmlnaW5hbHMvMDk1MWMyMzgtZGZmNi01NGU1LTk3YjYtNzVjMzk2N2Q4NDY4LzBlMDZhNTNiLTI3ZTItNWI2OC1hYTllLTY0MWZiYmNmNmZhMCIsImZhbGxiYWNrIjpudWxsLCJzb3VyY2UiOnsidXJsIjoiIiwic2hhMjU2IjoiZDM5NzZlMDg3OGFhNTljOTgwNWJkOTcyYWMxYmYxZjE0ZTAzZGMyYTM3OGQ2YmZhMTkxMjY3ZTRjODQ4YWEzZiIsIndpZHRoIjoyNzUyLCJoZWlnaHQiOjE1MzZ9LCJjcm9wcyI6e319',
    sig: '398a10fe99875294cc81c2497d48bfd2f5512ff15631f7502d556f8901a5fa7c',
    width: 2752,
    height: 1536,
  },
  'tryg-logo': {
    recipe:
      'eyJ2ZXJzaW9uIjoiY2YtbWVkaWEtdjEiLCJrZXkiOiJvcmlnaW5hbHMvY2JlMDE0NmItMDQ0Yi01N2JjLTliZTktNDM4YzA1MzM2OTMyLzEyYTcyNzVlLWFjMjYtNWU4ZC05YTAyLWRmNTYxMTAyMGMxNSIsImZhbGxiYWNrIjpudWxsLCJzb3VyY2UiOnsidXJsIjoiIiwic2hhMjU2IjoiYzU1MjRkMDAxZjc5YTg1MGZjMzM5ZTJjNjM5ZWE2ZjA2Yzk4MzI5ZWIyMDZlZGQxYzk1MzA2ZjkwY2Q5NmQ5NyIsIndpZHRoIjoyNTYwLCJoZWlnaHQiOjEwOTh9LCJjcm9wcyI6e319',
    sig: '63ad7a73f3491234267a041a72b2308596ec5a43148687556ddf6125505e1aae',
    width: 2560,
    height: 1098,
  },
  'trygg-hansa-logo': {
    recipe:
      'eyJ2ZXJzaW9uIjoiY2YtbWVkaWEtdjEiLCJrZXkiOiJvcmlnaW5hbHMvMDM4MzM2NGQtYzE0Yy01MGNjLWEwZDItZDVhZWFjMzA5Y2IwL2Q5ZjMyNWI1LTA2MDUtNTBhNS1iMTJiLThkMDJjYWM2MzgwNCIsImZhbGxiYWNrIjpudWxsLCJzb3VyY2UiOnsidXJsIjoiIiwic2hhMjU2IjoiMDFhYzRmMjkzYWEyNjU5MGJhOTFhNjA5YTZlMDAyMmM3MmE3ZmFmYWYwNjk0YjBlNzJhZDJmYjgxY2VhMGJjZiIsIndpZHRoIjoxMzEwLCJoZWlnaHQiOjI0MH0sImNyb3BzIjp7fX0',
    sig: '9634f55529ec603fa5eeb27d1a8a6084cdc31312d568d4a4241d83287097af04',
    width: 1310,
    height: 240,
  },
};

export type StaticImageName = keyof typeof STATIC_IMAGES;

const MEDIA_BASE_URL =
  process.env.NEXT_PUBLIC_MEDIA_BASE_URL?.replace(/\/$/, '') || 'https://media.getapet.com';

// Mirrors the backend's config/media.php profiles, so design images render like uploads.
const PROFILES = {
  avatar: { family: 'square', widths: [128, 256], aspectRatio: 1 },
  card: { family: 'landscape', widths: [360, 480, 640, 768], aspectRatio: 4 / 3 },
  large: {
    family: 'landscape',
    widths: [360, 480, 640, 768, 960, 1120, 1280],
    aspectRatio: 4 / 3,
  },
  full: { family: 'full', widths: [480, 640, 768, 1024, 1280, 1536, 1920, 2560], aspectRatio: 0 },
  square: { family: 'square', widths: [360, 480, 640, 768], aspectRatio: 1 },
  portrait: { family: 'portrait', widths: [360, 480, 640, 768], aspectRatio: 3 / 4 },
} as const;

type ImageFamily = (typeof PROFILES)[keyof typeof PROFILES]['family'];

export function staticImageUrl(name: StaticImageName, family: ImageFamily = 'full', width = 1280) {
  const { recipe, sig } = STATIC_IMAGES[name];
  return `${MEDIA_BASE_URL}/cf/image/${recipe}/${family}/${width}?sig=${sig}`;
}

export function staticImage(name: StaticImageName): MediaImageSource {
  const source = STATIC_IMAGES[name];
  const imageVersions: MediaImageVersions = {};
  for (const [profile, { family, widths, aspectRatio }] of Object.entries(PROFILES)) {
    const versions = new Map<number, { width: number; height: number; url: string }>();
    for (const requested of widths) {
      // Full-size versions never upscale, so their width is capped at the source width.
      const width = aspectRatio ? requested : Math.min(requested, source.width);
      if (versions.has(width)) continue;
      const height = Math.round(
        aspectRatio ? width / aspectRatio : (width * source.height) / source.width,
      );
      versions.set(width, { width, height, url: staticImageUrl(name, family, requested) });
    }
    imageVersions[profile as keyof typeof PROFILES] = [...versions.values()];
  }
  const full = imageVersions.full!;
  return {
    url: (full.find((version) => version.width === Math.min(1280, source.width)) ?? full[0]!).url,
    image_versions: imageVersions,
  };
}
